const STORAGE_KEY = 'fanvue_oauth_sessions'
const MAX_AGE_MS = 30 * 60 * 1000

function readSessions() {
  if (typeof window === 'undefined') return {}
  try {
    const parsed = JSON.parse(window.localStorage?.getItem(STORAGE_KEY) || '{}')
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (_) {
    return {}
  }
}

function writeSessions(sessions) {
  if (typeof window === 'undefined') return
  window.localStorage?.setItem(STORAGE_KEY, JSON.stringify(sessions || {}))
}

export function rememberFanvueOAuthSession({ state, modelId, authUrl, source }) {
  const key = String(state || '').trim()
  if (!key || (!modelId && source !== 'signup')) return
  const now = Date.now()
  const sessions = readSessions()
  for (const [sessionState, item] of Object.entries(sessions)) {
    if (!item?.startedAt || now - Number(item.startedAt) > MAX_AGE_MS) {
      delete sessions[sessionState]
    }
  }
  sessions[key] = {
    modelId: modelId ? String(modelId) : '',
    authUrl: authUrl || '',
    source: source || '',
    startedAt: now,
  }
  writeSessions(sessions)
}

export function getFanvueOAuthSession(state) {
  const key = String(state || '').trim()
  if (!key) return null
  const sessions = readSessions()
  const session = sessions[key] || null
  if (!session?.startedAt || Date.now() - Number(session.startedAt) > MAX_AGE_MS) {
    if (session) {
      delete sessions[key]
      writeSessions(sessions)
    }
    return null
  }
  return session
}

export function clearFanvueOAuthSession(state) {
  const key = String(state || '').trim()
  if (!key) return
  const sessions = readSessions()
  delete sessions[key]
  writeSessions(sessions)
}
